import { motion } from "framer-motion";

const SloganSection = () => {
  return (
    <section className="section-shell overflow-hidden bg-background">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,hsl(206_90%_58%/0.16)_0%,transparent_58%)]" />
      <div
        className="absolute inset-0 opacity-[0.028]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, hsl(var(--primary)), hsl(var(--primary)) 1px, transparent 1px, transparent 54px)",
        }}
      />
      <div className="absolute inset-y-0 left-1/2 hidden w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-white/8 to-transparent lg:block" />

      <div className="container relative mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mx-auto max-w-5xl text-center"
        >
          <div className="section-line section-line-center mx-auto mb-7" />
          <span className="mb-8 block text-xs uppercase tracking-[0.4em] text-primary/95 md:text-sm">
            Unser Versprechen
          </span>
          <blockquote
            className="text-4xl font-bold leading-[1.02] tracking-[0.02em] md:text-6xl lg:text-7xl"
            style={{ fontFamily: "var(--font-display-strong)" }}
          >
            Während andere im{" "}
            <span className="text-muted-foreground">Betonwerk warten</span>
            <span className="text-muted-foreground">,</span>
            <br />
            <span className="text-primary">arbeiten Sie</span> bei uns schon.
          </blockquote>
          <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-muted-foreground md:text-base">
            Die Station spart nicht nur Wege, sondern bringt Entscheidungsfreiheit zurück auf die
            Baustelle: Menge, Zeitpunkt und Tempo bleiben bei Ihnen.
          </p>
          <p className="mt-10 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
            — Beton2Go by Romano
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SloganSection;
